module.exports = __webpack_public_path__ + "img/img_view_direct_lg_02.76dba238.png";